import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { SlothAssetSlot } from '@/components/character/sloth-asset-slot';
import type { SlothState } from '@/components/character/sloth-states';

interface EmptyStateProps {
  title: string;
  description: string;
  slothState?: SlothState;
  action?: ReactNode;
  className?: string;
}

/** 空狀態一律說明原因與下一步，不只放一句「沒有資料」（spec 24）。 */
export function EmptyState({
  title,
  description,
  slothState = 'empty',
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-4 rounded-[var(--radius-surface)]',
        'border border-dashed border-border px-8 py-12 text-center',
        className,
      )}
    >
      <div className="w-24 opacity-90">
        <SlothAssetSlot state={slothState} decorative />
      </div>
      <div className="space-y-1.5">
        <p className="text-[1rem] font-medium">{title}</p>
        <p className="mx-auto max-w-md text-[0.875rem] leading-relaxed text-text-muted">
          {description}
        </p>
      </div>
      {action}
    </div>
  );
}
